import axios from "axios";

import {
  CREATENEWAPP,
  DEVLOPERLOGIN,
  DEVLOPERSIGNUP,
  DEVLOPERALLAPPS,
  GETAPPOVERVIEWDETAILS,
  GETAPPPERMISSIONDETAILS,
  REQUESTACCESS,
  GETPERMISSIONSTATUS,
  UPLOADIMAGEAPI,
  SAVECONFIGURATIONSAPI,
  REMOBEBANNERAPI,
  UPLOADBANNERAPI,
  ACTIVEPLANAPI,
  EDITPLANAPI,
  ADDPLANAPI,
  SUBMITAPP,
  GETLISTOFCATEGORY,
  UPDATEPASSWORD,
  DEVLOPERALLAPPSSEARCH,
  FORGETPASSWORDAPI,
  UPDATEPASSWORDAPI,
} from "./endpoint";
import { Api } from "@mui/icons-material";

const axiosInstanceTracking = axios.create({});
axiosInstanceTracking.interceptors.request.use((config) => {
  const env = process.env.REACT_APP_ENV;
  // const companyId = getCompanyId();
  const token = localStorage.getItem("developer_token");
  if (env == "production") {
    config.params = {
      ...config.params,
      app_id: "1",
      company_id: "1",
    };
    config.headers["Authorization"] = "Bearer " + token;
  }
  config.params = {
    ...config.params,
    app_id: "1",
    company_id: "1",
  };
  if (config?.data?.Content) {
    config.headers["Content-Type"] = config?.data?.Content;
  } else {
    config.headers["Content-Type"] = "application/json";
  }
  config.headers["Access-Control-Allow-Origin"] = "*";

  config.headers["Authorization"] = "Bearer " + token;
  return config;
});

axiosInstanceTracking.interceptors.response.use(
  function (response) {
    // Any status code that lie within the range of 2xx cause this function to trigger
    // Do something with response data
    return response.data;
  },
  function (error) {
    // Any status codes that falls outside the range of 2xx cause this function to trigger
    // Do something with response error
    return Promise.reject(error.response.data);
  }
);

export const developerLogin = async (data: any) => {
  return DEVLOPERLOGIN(data);
};
export const forgotPasswordApi = async (data: any) => {
  return FORGETPASSWORDAPI(data);
};
export const updatePasswordApi = async (data: any) => {
  return UPDATEPASSWORDAPI(data);
};


export const developerSignUp = async (data: any) => {
  return DEVLOPERSIGNUP(data);
};

export const createNewApp = async (data: any) => {
  return CREATENEWAPP(data);
};

export const developerAllApps = async (data: any) => {
  return DEVLOPERALLAPPS(data);
};

export const developerAllAppsSearch = async (pageNumber: any, searchKey: string) => {
  return DEVLOPERALLAPPSSEARCH(pageNumber, searchKey);
};

export const getAppOverViewDetails = async (app_id: any) => {
  return GETAPPOVERVIEWDETAILS(app_id);
};

export const GetAppPermissions = async () => {
  return GETAPPPERMISSIONDETAILS();
};

export const RequestAccess = async (data: any, app_id) => {
  return REQUESTACCESS(data, app_id);
};

export const PermissionStatus = async (status: any, app_id: any) => {
  return GETPERMISSIONSTATUS(status, app_id);
};
export const uploadImageApi = async (data: any) => {
  return UPLOADIMAGEAPI(data);
};
export const removebannerApi = async (app_id, data: any) => {
  return REMOBEBANNERAPI(app_id, data);
};

export const saveconfigurationsApi = async (data: any) => {
  return SAVECONFIGURATIONSAPI(data);
};
export const uploadBannerApi = async (app_id: any, data: any) => {
  return UPLOADBANNERAPI(app_id, data);
};
export const activePlanApi = async (app_id: any, data: any) => {
  return ACTIVEPLANAPI(app_id, data);
};

export const editPlanApi = async (app_id: any, data: any) => {
  return EDITPLANAPI(app_id, data);
};
export const addPlanApi = async (app_id: any, data: any) => {
  return ADDPLANAPI(app_id, data);
};
export const submitAppApi = async (app_id: any, data: any) => {
  return SUBMITAPP(app_id, data);
};

export const listOfCategory = async () => {
  return GETLISTOFCATEGORY();
};

export const forgotPassword = async (data: any) => {
  return UPDATEPASSWORD(data);
};
